/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { openModal } from 'store/modals/actions';
import { setAgentId, setSelectedCloudAgent, getAgent, unSelectAll } from 'store/Agents/actions';
import { useDispatch, useSelector } from 'react-redux';
import { SelectShowCloudAgents } from 'store/Agents/selectors';
import { MODAL_AGENT_DETAIL } from 'store/modals/modals';
import Button from './styled';

const ConfigureAndRun = ({ agent }) => {
  const dispatch = useDispatch();
  const id = get(agent, 'id', null);
  const isOnline = get(agent, 'is_online', true);
  const status = get(agent, 'status', 'online');
  const disabled = !isOnline || (isOnline && status !== 'online');
  const showCloudAgents = useSelector(SelectShowCloudAgents);

  const onTriggerAgent = () => {
    if (id) {
      dispatch(unSelectAll());
      if (showCloudAgents) {
        dispatch(setAgentId(id));
        dispatch(setSelectedCloudAgent(agent));
      }
      dispatch(getAgent(id));
      dispatch(openModal(MODAL_AGENT_DETAIL));
    }
  };

  return (
    <Button id="modal-user-agent-run-btn" onClick={ onTriggerAgent } disabled={ disabled }>Configure and Run</Button>
  );
};

ConfigureAndRun.propTypes = {
  agent: PropTypes.object.isRequired
};

export default ConfigureAndRun;
